function positiveInteger(value, fallback) {
  const number = Number(value)
  return Number.isSafeInteger(number) && number > 0 ? number : fallback
}

export function assignmentHistoryParams(params = {}, { itemScoped = false } = {}) {
  const query = {
    page: positiveInteger(params.page, 1),
    limit: Math.min(100, positiveInteger(params.limit, 20)),
  }
  if (itemScoped) return query
  query.status = ['all', 'active', 'canceled'].includes(params.status) ? params.status : 'all'
  const projectId = positiveInteger(params.project_id, null)
  if (projectId !== null) query.project_id = projectId
  return query
}

const fileReferenceLabels = [
  ['input_version_id', '입력 기록 #'],
  ['output_id', '산출물 #'],
  ['run_id', '실행 #'],
  ['source_run_id', '원본 실행 #'],
  ['review_attempt_id', '검토 회차 #'],
  ['review_target_id', '검토 대상 #'],
  ['target_version', '검토 버전 '],
  ['revision_id', '수정 기록 #'],
]

export function readableAssignmentHistoryFile(file) {
  return typeof file?.file_id === 'number' && Number.isSafeInteger(file.file_id) && file.file_id > 0
}

export function assignmentHistoryFileReferenceText(file) {
  if (!readableAssignmentHistoryFile(file)) return ''
  return fileReferenceLabels
    .filter(([field]) => file[field] !== null && file[field] !== undefined && file[field] !== '')
    .map(([field, label]) => `${label}${file[field]}`)
    .join(' · ')
}

export function assignmentHistoryFileSelection(file, occurrenceId) {
  if (!readableAssignmentHistoryFile(file)) return null
  const selection = { occurrence_id: occurrenceId }
  for (const field of ['role', 'file_id', 'display_name', 'mtd_version_id', 'mtd_version_hash', ...fileReferenceLabels.map(([field]) => field)]) {
    if (file[field] !== null && file[field] !== undefined) selection[field] = file[field]
  }
  return selection
}
